import React from "react";
import { Stack } from "@bookingcom/bui-react";
import { Breakdown } from "./Breakdown";
import { Installments, Atol, Disclaimers } from "./banners";
import {
  useUnifiedPriceBreakdownTicketTypeController,
  type UnifiedPriceBreakdownTicketTypeControllerProps
} from "./useUnifiedPriceBreakdown.TicketType.controller";
import useEvents from "hooks/useEvents";

export type UnifiedPriceBreakdownTicketTypeProps = UnifiedPriceBreakdownTicketTypeControllerProps;

export function UnifiedPriceBreakdownTicketType(props: UnifiedPriceBreakdownTicketTypeProps) {
  const {
    addedItems,
    isHungaryDepartingRyanAir,
    disclaimers,
    isWithDiscount,
    unifiedPriceBreakdown,
    routeName,
    expandedByDefault
  } = useUnifiedPriceBreakdownTicketTypeController(props);

  const { grumble } = useEvents();

  if (!unifiedPriceBreakdown) {
    grumble("unifiedPriceBreakdown object unavailable", { controller: "TicketType", routeName });
    return null;
  }

  return (
    <Stack gap={4}>
      <Breakdown
        {...unifiedPriceBreakdown}
        addedItems={addedItems}
        isHungaryDepartingRyanAir={isHungaryDepartingRyanAir}
        expandedByDefault={expandedByDefault}
        isWithDiscount={isWithDiscount} // flights_web_unified_price_breakdown
      />
      <Disclaimers disclaimers={disclaimers} />
      <Atol />
      <Installments />
    </Stack>
  );
}
